module.exports = __webpack_public_path__ + "static/media/our-team.93122152.svg";